import { TrackingPageModel } from '../tracking-page.model';
import { getAsset, getProductItems } from './helpers';
import {
  getFontConfig,
  getSocialIcons,
  getFooterItems,
  getLogo,
  getLanguageMenu,
  white
} from './helpers';

export const food: TrackingPageModel = {
  languageMenu: getLanguageMenu('Poppins', '#000000ff'),
  searchPageInput: {
    backgroundColor: '#ffffffff',
    borderColor: '#ffffffff',
    borderRadius: 22,
    borderWidth: 1,
    shadow: 'none',
    ...getFontConfig('Poppins', '#7b8c6dff')
  },
  searchPageTitle: {
    fontSize: 18,
    ...getFontConfig('Nunito Sans', '#47553dff', '700')
  },
  background: {
    color: white,
    useBackgroundImage: true,
    imageUrl: getAsset('/images/themes/food.png'),
    backgroundMode: 'cover',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat'
  },
  card: {
    backgroundColor: '#ffffff',
    linksColor: '#fba129ff',
    linksUnderline: false,
    headerBackground: '#ffffff',
    footerBackground: '#ffffff',
    borderColor: '#d5d9e1',
    borderRadius: 4,
    borderWidth: 0,
    shadow: 'none',
    trackingNumberField: 'trackingNumber',
    ...getFontConfig('Ubuntu', '#474b44ff')
  },
  orderCard: {
    backgroundColor: '#ffffff',
    linksColor: '#5780ff',
    linksUnderline: false,
    headerBackground: '#ffffff',
    footerBackground: '#ffffff',
    borderColor: '#d5d9e1',
    borderRadius: 4,
    borderWidth: 1,
    shadow: 'none',
    ...getFontConfig('Nunito Sans', '#2E4068')
  },
  orderNumber: {
    alignment: 'center',
    fontSize: 15,
    ...getFontConfig('Nunito Sans', '#b0c5a0ff', '700')
  },
  orderStatus: {
    alignment: 'center',
    fontSize: 19,
    ...getFontConfig('Nunito Sans', '#414a3aff', '900')
  },
  orderLastUpdated: {
    alignment: 'center',
    fontSize: 12,
    ...getFontConfig('Noto Sans', '#272727b3')
  },
  notYetShippedItemsTitle: {
    alignment: 'center',
    fontSize: 18,
    ...getFontConfig('Noto Sans', '#d13232ff')
  },
  orderStatusOn: true,
  orderNumberOn: true,
  orderLastUpdatedOn: true,
  orderItemsFrame: {
    on: true,
    scroll: false,
    itemsLimit: 4,
    borderColor: '#5780ff',
    borderWidth: 0,
    borderRadius: 25,
    backgroundColor: '#b0c5a0ff',
    shadow: 'none',
    button: {
      on: true,
      backgroundColor: '#798f69ff',
      borderColor: '#ffffffff',
      borderRadius: 14,
      borderWidth: 0,
      shadow: 'none',
      ...getFontConfig('Nunito Sans', white, '700')
    },
    itemCard: {
      backgroundColor: '#ffffffff',
      borderColor: '#2E4068',
      borderRadius: 15,
      borderWidth: 0,
      shadow: 'none',
      title: {
        alignment: 'left',
        fontSize: 16,
        ...getFontConfig('Nunito Sans', '#495044ff', '700')
      },
      info: {
        alignment: 'left',
        fontSize: 13,
        ...getFontConfig('Nunito Sans', '#7d7d7dff')
      },
      showAttributes: false
    }
  },
  searchButton: {
    on: true,
    backgroundColor: '#fba129ff',
    borderColor: '#fba129ff',
    borderRadius: 22,
    borderWidth: 1,
    shadow: 'none',
    ...getFontConfig('Poppins', '#ffffffff', '700')
  },
  detailsButton: {
    backgroundColor: '#fba129ff',
    borderColor: '#5780ff',
    borderRadius: 21,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Nunito Sans', white, '700')
  },
  trackButton: {
    backgroundColor: '#fba129ff',
    borderColor: '#ee7227',
    borderRadius: 22,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Nunito Sans', white, '700')
  },
  pageScroll: {
    scrollColor: '#2E4068',
    borderRadius: 2,
    backgroundColor: '#ffffff00'
  },
  scripts: {
    head: null,
    body: null
  },
  logo: getLogo(getAsset('/images/themes/food-logo.png')),
  socialIcons: getSocialIcons('#fba129ff'),
  sidebar: {
    parcelIcon: 'icon-parcel',
    groupIcon: 'icon-track_number',
    backgroundColor: '#ffffff',
    borderColor: '#CED2DC',
    borderRadius: 15,
    borderWidth: 0,
    shadow: 'none',
    sidebarField: null,
    ...getFontConfig('Nunito', '#2e532aff', '700')
  },
  footer: {
    backgroundColor: '#eff4edff',
    linksColor: '#fba129ff',
    linksUnderline: false,
    ...getFooterItems(),
    ...getFontConfig('Poppins', '#798f69ff')
  },
  header: {
    backgroundColor: '#eff4edff'
  },
  faviconUrl: '/assets/favicon/favicon-32x32.png',
  sidebarProductsFeed: {
    on: false,
    backgroundColor: '#ffffffff',
    borderColor: '#d5d9e1',
    borderRadius: 15,
    borderWidth: 0,
    shadow: 'none',
    card: {
      backgroundColor: '#ffffff',
      borderColor: '#ffffff',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      button: {
        backgroundColor: '#fba129ff',
        borderColor: '#5780ff',
        borderRadius: 22,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Poppins', white, '700')
      },
      buttonText: 'Buy Now',
      title: {
        alignment: 'center',
        fontSize: 15,
        ...getFontConfig('Nunito Sans', '#3e4737ff', '700')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Nunito Sans', '#ff7272ff')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 17,
        ...getFontConfig('Nunito Sans', '#4a6635ff', '700')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('food'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#ff9f26ff',
      arrowSize: 30
    }
  },
  mainProductsFeed: {
    on: true,
    backgroundColor: '#ffffffff',
    borderColor: '#d5d9e1',
    borderRadius: 15,
    borderWidth: 0,
    shadow: 'none',
    card: {
      backgroundColor: '#ffffff',
      borderColor: '#ffffff',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      button: {
        backgroundColor: '#fba129ff',
        borderColor: '#5780ff',
        borderRadius: 22,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Poppins', white, '700')
      },
      buttonText: 'Buy Now',
      title: {
        alignment: 'center',
        fontSize: 15,
        ...getFontConfig('Nunito Sans', '#3e4737ff', '700')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Nunito Sans', '#ff7272ff')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 17,
        ...getFontConfig('Nunito Sans', '#4a6635ff', '700')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('food'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#ff9f26ff',
      arrowSize: 30
    }
  },
  seoTitle: ''
};
